export default __webpack_public_path__ + "static/media/banners_5.31edfcae.png";